import {
  ADMIN_CREATE_USER,
  ADMIN_CURRENT_USER,
  ADMIN_DELETE_USER,
  ADMIN_ROLES,
  ADMIN_UPDATE_USER,
  ADMIN_USERS,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";
import { toast } from "react-toastify";

export const createUser = (email, name, roleId) => {
  const requestURL = ADMIN_CREATE_USER;

  const reqParams = {
    method: methodType.POST,
    url: requestURL,
    data: { email: email, name: name, role_id: roleId },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getRoles = () => {
  const requestURL = ADMIN_ROLES;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateUser = (email, name, roleId) => {
  const requestURL = ADMIN_UPDATE_USER;
  const obj = {email: email};

  if (name) {
    obj["name"] = name;
  }

  if (roleId) {
    obj["role_id"] = roleId;
  }

  const reqParams = {
    method: methodType.PUT,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getUsers = (page, limit) => {
  const requestURL = ADMIN_USERS;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCurrentUser = () => {
  const requestURL = ADMIN_CURRENT_USER;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      localStorage.setItem("userInfo", JSON.stringify(res.data));
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response?.data?.error || "Couldn't find user details");
      if (
        err.response?.data?.error === "You are not registered in the system"
      ) {
        setTimeout(() => {
          localStorage.clear();
          window.location.href = "/access-denied?access=false";
        }, 200);
      }

      throw err;
    });
};

export const deleteUser = (email) => {
  const requestURL = ADMIN_DELETE_USER;

  const reqParams = {
    method: methodType.DELETE,
    url: requestURL,
    data: {email: email},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
